// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-wrapper.loderhide {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/loader/loader.component.scss","webpack://./../contandoui2.0%20-%20TP/src/app/shared/components/loader/loader.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;ACCF","sourcesContent":[".loader-wrapper.loderhide {\n  display: none;\n}",".loader-wrapper.loderhide {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
